import React from 'react';
import styled from 'styled-components';
import { useHistory, useParams } from 'react-router-dom';
import { FaCheckCircle } from 'react-icons/fa';

import { Button, useScreenQuery } from 'playup-web-core';

import QuestionsAndHelp from '../USFooter/QuestionsAndHelp';
import formatCurrency from '../../../utils/formatCurrency';
import { BodyContainer, BoldText, NormalText } from './USWithdraw';
import PortalSessionContext from '../../../contexts/PortalSessionContext/PortalSessionContext';
import { WithdrawMethods } from './USWithdrawService';

const USWithdrawSuccess = ({ withdrawAmount }: Props) => {
	const { isSmall } = useScreenQuery();
	const { user } = React.useContext(PortalSessionContext);
	const history = useHistory();
	const params = useParams() as { paymentMethodName: string };

	const selectedPaymentMethod = Object.values(WithdrawMethods).find((m) => {
		return m.name === params.paymentMethodName;
	});

	const onCloseClick = () => {
		history.push('/');
	};

	return (
		<BodyContainer isSmallScreen={isSmall}>
			{selectedPaymentMethod && (
				<LogoContainer>
					{selectedPaymentMethod.icon}
					<VerifiedIcon $isSmallScreen={isSmall} />
				</LogoContainer>
			)}
			<TextContainer isSmallScreen={isSmall}>
				<BoldText isSmallScreen={isSmall}>
					{withdrawAmount && `$${formatCurrency(withdrawAmount)}`} Withdraw Requested
				</BoldText>
				<NormalText isSmallScreen={isSmall}>
					Your withdrawal request will be processed as soon as possible. Please allow 2-3 business days for it to appear
					in your destination account.
				</NormalText>
				<BoldText isSmallScreen={isSmall}>Available Balance: {formatCurrency(user?.available_balance)}</BoldText>
			</TextContainer>
			<StyledButton kind="white" type="submit" onClick={onCloseClick}>
				Done
			</StyledButton>
			<QuestionsAndHelp />
		</BodyContainer>
	);
};

export default USWithdrawSuccess;

interface Props {
	withdrawAmount: number;
}

const LogoContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
`;

const VerifiedIcon = styled(FaCheckCircle)<{ $isSmallScreen: boolean }>`
	height: ${({ $isSmallScreen }) => ($isSmallScreen ? '36px' : '54px')};
	width: ${({ $isSmallScreen }) => ($isSmallScreen ? '36px' : '54px')};
	color: ${({ theme }) => theme.colors.success};
	margin: ${({ $isSmallScreen }) => ($isSmallScreen ? '15px' : '18px')};
`;

const TextContainer = styled.div<{ isSmallScreen: boolean }>`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;

	p {
		margin: ${({ isSmallScreen }) => (isSmallScreen ? '8px auto' : '12px auto')};
	}
`;

const StyledButton = styled(Button)`
	margin: 20px auto;
`;
